import {
	Breakpoints,
	InteractionLayer,
	LayerWrapper,
	styled,
	ThemeName,
	ThemeProvider,
} from '@volkswagen-onehub/components-core';
import {
	InteractionLayerSizeV2,
	LayerHandleV2,
	LayerManagerV2,
	ShimBackgroundTypeV2,
} from '@volkswagen-onehub/layer-manager';
import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { OfertasContext, useFeatureServices } from '../../context/ofertas-context';
import { GRADIENT } from '../constant-styles';

const InteractionDiv = styled.div`
	& > div {
		background-image: ${GRADIENT.LAYER};

		@media (max-width: ${Breakpoints.b960}px) {
			width: 100%;
			height: 100%;
		}
	}
`;

export const ContentLayer: React.FC<{
	children: React.ReactElement;
	theme?: ThemeName;
	layerSize: InteractionLayerSizeV2;
	isLayerVisible: boolean;
	className: string;
}> = ({ children, theme, layerSize, isLayerVisible }) => {
	const ofertasContext = useContext(OfertasContext);
	const layerManager = useFeatureServices()['layer-manager'] as LayerManagerV2;
	const layerRef = useRef<LayerHandleV2<unknown> | null>(null);

	const renderOfertaLayer = useCallback(() => {
		return (
			<OfertasContext.Provider value={ofertasContext}>
				<LayerWrapper contentCentered>
					<InteractionDiv className="interaction-div">
						<InteractionLayer aria-label="interaction-layer" size={layerSize} active>
							<ThemeProvider theme={theme ? theme : 'inverted'}>
								{React.cloneElement(children, { layerRef })}
							</ThemeProvider>
						</InteractionLayer>
					</InteractionDiv>
				</LayerWrapper>
			</OfertasContext.Provider>
		);
	}, [children, layerSize, ofertasContext, theme]);

	useEffect(() => {
		if (!isLayerVisible || layerRef.current) {
			return;
		}

		const layer = layerManager.openInteractionLayer(
			renderOfertaLayer,
			{},
			{ size: layerSize, shimBackgroundType: ShimBackgroundTypeV2.OPAQUE },
		);
		layerRef.current = layer;
	}, [isLayerVisible, layerManager, layerSize, renderOfertaLayer]);

	const renderInteractionLayer = (): null => {
		return null;
	};

	return <>{isLayerVisible && renderInteractionLayer()}</>;
};
